import { Add, Remove } from "@mui/icons-material";
import { IconButton, Paper } from "@mui/material";
import React from "react";
import { useMap } from "react-leaflet";

const CustomZoomControls: React.FC = () => {
  const map = useMap();

  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: "absolute",
        bottom: 20,
        right: 20,
        zIndex: 1000,
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <IconButton
        onClick={handleZoomIn}
        sx={{
          width: 40,
          height: 40,
          borderRadius: 0,
          color: "text.primary",
          backgroundColor: "background.paper",
          border: "none",
          borderBottom: "1px solid",
          borderBottomColor: "divider",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          "&:active": {
            backgroundColor: "action.selected",
          },
        }}
        aria-label="Zoom in"
      >
        <Add fontSize="small" />
      </IconButton>

      <IconButton
        onClick={handleZoomOut}
        sx={{
          width: 40,
          height: 40,
          borderRadius: 0,
          color: "text.primary",
          backgroundColor: "background.paper",
          border: "none",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          "&:active": {
            backgroundColor: "action.selected",
          },
        }}
        aria-label="Zoom out"
      >
        <Remove fontSize="small" />
      </IconButton>
    </Paper>
  );
};

export default CustomZoomControls;
